/**
 * Phone number validation utilities
 */

export interface ValidationResult {
  ok: boolean;
  msg: string;
}

/**
 * Validates a US phone number
 * @param raw - Raw phone number string
 * @returns Validation result with ok flag and error message
 */
export const validatePhoneNumber = (raw: string): ValidationResult => {
  const digits = (raw || '').replace(/\D/g, '');
  
  if (!digits) {
    return { ok: false, msg: 'Please enter a phone number' };
  }
  
  if (digits.length !== 10) {
    return { ok: false, msg: 'US phone numbers must be 10 digits (e.g., 5551234567)' };
  }
  
  if (digits[0] === '0' || digits[0] === '1') {
    return { ok: false, msg: 'Phone number cannot start with 0 or 1' };
  }
  
  if (digits[1] === '0' || digits[1] === '1') {
    return { ok: false, msg: 'Invalid area code format' };
  }
  
  return { ok: true, msg: '' };
};

/**
 * Checks if a phone number is in a valid format for Firebase Auth
 * @param e164Phone - Phone number in E.164 format
 * @returns True if valid, false otherwise
 */
export const isValidE164Format = (e164Phone: string): boolean => {
  return e164Phone.startsWith('+') && e164Phone.length >= 10;
};

